import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/buttonDialogForm";
import FormField from "components/formField";
//import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import ShareIcon from '@material-ui/icons/ShareOutlined';

export const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

export const DISPATCH_CONTRACT = gql`
  mutation DispatchContractBundle($input: DispatchContractBundleInput!) {
    dispatchContractBundle(
      input: $input
    ) {
      code
      success
      message
    }
  }  
`;

export default function ({ contract }) {
  const { id } = useParams();

  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const [
    dispatchContractBundle,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(DISPATCH_CONTRACT);

  const { register, control, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {
    const { } = data;

    const variables = {
      input: {
        id: contract.id
      }
    };

    dispatchContractBundle({
      variables
    });

  };

  if (queryError) return <p>ERROR: {queryError.message}</p>;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Smistamento dei contratti avviato con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nello smistamento dei contratti"}
      />
      <DialogForm
        id="dispatch-contract"
        title={
          queryData &&
          `Smistamento Contratti ${queryData.cooperative.businessName}`
        }
        subTitle={queryData && `La seguente procedura avvierà lo smistamento dei contratti per la società ${queryData.cooperative.businessName}, partendo dalle buste paga ${contract.title}.`}
        buttonTitle='Smista contratti'
        formState={formState}
        icon={ShareIcon}
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* <FormField
            id="code"
            name="code"
            label="Codice"
            type="text"
            inputRef={register({ required: "Inserisci il codice." })}
            error={errors.password}
          />
          <FormField
            id="stip"
            name="agreementDate"
            label="Data stipula"
            type="date"
            inputRef={register({ required: "Inserisci data di stipula." })}
            error={errors.password}
          />
          <FormField
            id="start"
            name="startDate"
            label="Data inizio"
            type="date"
            inputRef={register({ required: "Inserisci data di inizio." })}
            error={errors.password}
          /> */}
          { false && <FormField
            id="contractSector"
            name="contractSector"
            label="Settore contratto"
            type="text"
            //inputRef={register({ required: "Inserisci il codice." })}
            control={control}
            error={errors.password}
          />}          
          { false && <FormField
            id="customersMode"
            name="customersMode"
            label="Smista verso committenti"
            type="switch"
            //inputRef={register()}
            control={control}
            error={errors.password}
          /> }           
      </DialogForm>
    </Fragment>
  );
}
